/* istanbul ignore file */
module.exports.colourPrimaryGrey = '#333333';
module.exports.colourWhite = '#ffffff';
module.exports.colourChiaGrey = '#a9a9a9';
module.exports.colourWaitroseGreen = '#5b8226';
module.exports.colourCorporateGreen = '#154734';
module.exports.colourCorporateLimeGreen = '#c4d600';
module.exports.colourNewGreen = '#0e893e';
module.exports.colourPartnerGreen = '#00b140';
/**
  @deprecated
 */
module.exports.colourWaitroseGreenOld = '#5c8018';
module.exports.colourOfferRed = '#a6192e';
module.exports.colourOfferOrangeStrip = '#dc4135';
module.exports.colourOfferRedStrip = '#d30b37';
module.exports.colourSuccessGreen = '#78be20';
module.exports.colourSuccessGreenTint = '#f1f8e8';
module.exports.colourWarning = '#f6a600';
module.exports.colourWarningTint = '#fef6e5';
module.exports.colourErrorRed = '#d50032';
module.exports.colourErrorTint = '#fae5ea';
module.exports.colourInformativeBlue = '#0074e8';
module.exports.colourInformativeBlueTint = '#e5f1fc';
/**
  @deprecated
 */
module.exports.colourPressedGreen = '#154734';
module.exports.colourFocusBlue = '#359cd4';
module.exports.colourHoverGreen = '#44693d';
module.exports.colourWaitroseGrey = '#53565a';
module.exports.colourEarlGrey = '#757575';
module.exports.colourOysterGrey = '#dddddd';
module.exports.colourMushroomGrey = '#eeeeee';
module.exports.colourScallopGrey = '#f3f3f3';
module.exports.colourEggshellGrey = '#fafafa';
module.exports.colourPrimaryGreyAlpha70 = 'rgba(51,51,51,0.7)';
module.exports.colourPrimaryGreyAlpha40 = 'rgba(51,51,51,0.4)';
module.exports.colourWhiteAlpha50 = 'rgba(255,255,255,0.5)';
module.exports.colourWhiteAlpha90 = 'rgba(255,255,255,0.9)';
module.exports.colourTransparent = 'rgba(0, 0, 0, 0)';
module.exports.colourSeasonalFiggyPudding = '#560734';
module.exports.colourSeasonalPigsInBlankets = '#e6007e';
module.exports.colourSeasonalChristmasTree = '#014533';
module.exports.colourSeasonalLittleTipple = '#003042';
module.exports.colourSeasonalKraft = '#e5b791';
module.exports.colourEasterBase = '#df1683';
module.exports.colourEasterHover = '#e9258f';
module.exports.colourEasterActive = '#df1683';
module.exports.colourChristmasBase = '#560734';
module.exports.colourChristmasHover = '#6c0942';
module.exports.colourChristmasActive = '#3d0525';
module.exports.colourDarkMalbec = '#650e35';
module.exports.colourMediumMerlot = '#81195a';
module.exports.colourRose = '#ed6fa3';
module.exports.colourGoldChardonnay = '#dcb37d';
module.exports.colourBrassCellofoil = 'linear-gradient(90deg, #d5ae79 0%, #debd8b 50%, #bc8e4e 100%)';
module.exports.colourChardonnayTint = '#f5e8d8';
module.exports.colourMerlotTint = '#f6dbed';
module.exports.colourDarkMerlotTint = '#c698b5';
module.exports.colourWineEvent = '#dcb37d';
module.exports.colourLimitedEdition = '#002f6c';
module.exports.colourUberGreen = '#06c167';
module.exports.colourDeliverooBlue = '#35b8b2';
module.exports.colourJustEatOrange = '#ff8100';
